import { getOccurrenceTimeslot } from '@griply/utils';
import { Task } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';

export const getTaskDuration = (task: Task, today: Date) => {
  if (task.type === TaskType.Task) {
    return task.timeslot?.duration ?? 0;
  }

  return (
    getOccurrenceTimeslot(task.schedules, { date: today, today })?.duration ?? 0
  );
};
